export default {"src":"/_next/static/media/Numerous_Thoughts_icon.c9ae37fa.svg","height":284,"width":284};